import LocalizedStrings from "react-localization";

export const BisListingMappedStrings = new LocalizedStrings({
  en: {
    title: "List BIS Mapped",
    IdBIS: "BIS ID",
    LabelBIS: "BIS Label",
    dissocier: "dissociate",
    MediaLabel: "Media Label",
    MediaId: "Media ID",
    DisplayMediaType: "Display Media ",
    dissociationInProgress: "Dissociation...",
    errors: {
      dissociationFailed: "Failed to dissociate BIS",
    },
  },
  fr: {
    title: "Liste de(s) sites BIS mappé(s)",
    IdBIS: "Id BIS",
    LabelBIS: " Libellé BIS",
    dissocier: "Désassocier",
    MediaLabel: "Libellé Média",
    MediaId: "Média ID",
    DisplayMediaType: "Display Media ",
    dissociationInProgress: "Dissociation en cours...",
    errors: {
      dissociationFailed: "Erreur lors de la Désassociation des BIS.",
    },
  },
});
